import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './GRAdmin.css';

function GRAdmin() {

  return (
    <>
      <Header />
      <div className="container">
        <div className="gr-admin-page">
          <h1>GR Admin</h1>
          <p className="admin-description">Manage all aspects of the GuyRules system</p>
          
          <div className="admin-cards">
            {/* Rules Admin Card */}
            <div className="admin-card">
              <Link to="/admin/rules" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-list-ul"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Rules Admin</h3>
                  <p>Manage rules and categories</p>
                </div>
              </Link>
            </div>

            {/* User Admin Card */}
            <div className="admin-card">
              <Link to="/admin/users" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-people"></i>
                </div>
                <div className="admin-card-content">
                  <h3>User Admin</h3>
                  <p>Manage users and profiles</p>
                </div>
              </Link>
            </div>

            {/* Submission Workflow Card */}
            <div className="admin-card">
              <Link to="/admin/submission-workflow" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-diagram-3"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Submission Workflow</h3>
                  <p>Manage rule submission workflow</p>
                </div>
              </Link>
            </div>

            {/* Stats for Nerds Card */}
            <div className="admin-card">
              <Link to="/admin/stats" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-graph-up-arrow"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Stats for Nerds</h3>
                  <p>Detailed statistics and analytics for rule submissions and voting patterns</p>
                </div>
              </Link>
            </div>

            {/* Analytics Card */}
            <div className="admin-card">
              <Link to="/admin/analytics" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-bar-chart"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Analytics</h3>
                  <p>View visitor analytics, page views, and site statistics</p>
                </div>
              </Link>
            </div>

            {/* Quiz Questions Card */}
            <div className="admin-card">
              <Link to="/admin/quiz-questions" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-question-square"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Quiz Questions</h3>
                  <p>Manage quiz questions and answers</p>
                </div>
              </Link>
            </div>

            {/* Glossary Admin Card */}
            <div className="admin-card">
              <Link to="/admin/glossary" className="admin-card-link">
                <div className="admin-card-icon">
                  <i className="bi bi-journal-text"></i>
                </div>
                <div className="admin-card-content">
                  <h3>Glossary Admin</h3>
                  <p>Manage glossary terms and map them to rules</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default GRAdmin;
